import { Observable } from 'rxjs';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import urlJoin from 'url-join';
import { Injectable } from '@angular/core';
import { PrenoteHistoryResult, PrenoteInfo } from './prenote.model';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class PrenoteRequestService {

  constructor(
    private http: HttpClient
  ) { }

  getHistory(
    tenantId: string,
    companyIds: string[]
  ): Observable<PrenoteHistoryResult[]> {
    let params = null;
    if (companyIds && companyIds.length > 0) {
      params = new HttpParams();
      params = this._appendArray(params, 'companyIds', companyIds);
    }
    return this.http.get<PrenoteHistoryResult[]>(
      this.getURI(tenantId, params, 'dd-prenote-customer-file-requests')
    );
  }

  hasPrenote(
    tenantId: string,
    companyIds: string[],
  ): Observable<PrenoteInfo[]> {
    const params = (new HttpParams())
      .append('tenantId', encodeURI(tenantId));
    return this.http.post<PrenoteInfo[]>(
      this.getURI(null, params, 'dd-prenote-file-requests', 'mostRecent'), companyIds
    );
  }

  sendPrenote(
    tenantId: string,
    companyIds: string[]
  ): Observable<HttpResponse<any>> {
      return this.http.post<HttpResponse<any>>(
        this.getURI(tenantId, null, 'dd-prenote-customer-file-requests', 'from-psg'), companyIds
      );
  }
  private getURI(tenantId: string, params: HttpParams, ...pathSegments: string[]) {
    let baseUri = `banking/v1/`;

    if (!this.IsNullOrEmpty(tenantId)) {
      baseUri = urlJoin(baseUri, `tenants`, encodeURI(tenantId));
    }

    const uri = urlJoin(this._getBaseUrl(), baseUri, ... pathSegments);

    return this.appendParams(uri, params);
  }

  private appendParams(uri: string, params: HttpParams): string {
    if (params) {
      uri += '?' + params.toString();
    }
    return uri;
  }

  private IsNullOrEmpty(str: string): boolean {
    return (typeof str === 'string' && str.length === 0) || str === null;
  }

  private _appendArray(
    params: HttpParams, name: string, value: any[]): HttpParams {

    value = value || [];

    if (value.length > 0) {
      return params.append(name, value.join(','));
    }

    return params;
  }

  private _getBaseUrl(): string {
    return ROUTE_TOKEN_GATEWAY_URL;
  }
}
